var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-builder-layout-placeholder-timeline" },
    _vm._l(_vm.PLACEHOLDER_SAMPLES, function (i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "layout-builder-layout-placeholder-timeline-row",
        },
        [
          _vm._m(0, true),
          _vm._v(" "),
          _vm._m(1, true),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "layout-builder-layout-placeholder-timeline-row-column-right",
            },
            [
              _c("div", {
                staticClass:
                  "layout-builder-layout-placeholder-timeline-row-column-right-line-top",
              }),
              _vm._v(" "),
              i % 2 === 0
                ? _c("div", {
                    staticClass:
                      "layout-builder-layout-placeholder-timeline-row-column-right-line-bottom",
                  })
                : _vm._e(),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "layout-builder-layout-placeholder-timeline-row-column-left",
      },
      [
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-timeline-row-column-left-line",
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "layout-builder-layout-placeholder-timeline-row-delimiter",
      },
      [
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-timeline-row-delimiter-line",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-timeline-row-delimiter-circle",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-timeline-row-delimiter-line",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }